import { isServer as i } from "../index.js";
var f = !1;
if (!i) try {
  var o = {};
  Object.defineProperty(o, "passive", {
    // eslint-disable-next-line getter-return
    get: function get() {
      f = !0;
    }
  }), window.addEventListener("test-passive", null, o);
} catch (_unused) {}
function c(e, t, n, a) {
  a === void 0 && (a = !1), i || e.addEventListener(t, n, f ? {
    capture: !1,
    passive: a
  } : !1);
}
function l(e, t, n) {
  i || e.removeEventListener(t, n);
}
function r(e) {
  e.stopPropagation();
}
function p(e, t) {
  (typeof e.cancelable != "boolean" || e.cancelable) && e.preventDefault(), t && r(e);
}
export { l as off, c as on, p as preventDefault, r as stopPropagation, f as supportsPassive };
